<template>
    <div id="app">
        <template v-if="!isLoading">
            <Header/>
            <home v-if="$route.path === '/'"/>
            <router-view/>
            <Footer></Footer>
            <GoTop></GoTop>
        </template>
        <div v-else class="loading-box" >
            <Spin size="small" />
            <Spin />
            <Spin size="large" />
        </div>
    </div>
</template>

<script>
    import Home from "./view/Home";
    export default {
        name: 'App',
        components: {Home},
        data() {
            return {
                isLoading: true
            }
        },
        created() {
            console.log(process.env.BASE_URL);
            this._initPage();
        },
        methods: {
            // 预加载图片
             _initPage() {
                 window.onload = async () => {
                     const imgUrl1 = require.context("@/assets/img/zhsh", false, /\.(jpg|jpeg|png)$/);
                     await imgUrl1.keys().forEach(path => {
                        let file = imgUrl1(path);
                        new Image().src = file;
                     })
                     const imgUrl2 = require.context("@/assets/img/soft", false, /\.(jpg|jpeg|png)$/);
                     await imgUrl2.keys().forEach(path => {
                        let file = imgUrl2(path);
                        new Image().src = file;
                     })
                     setTimeout(() => {
                         this.isLoading = false;
                     },2000)
                }
            }
        }
    }
</script>

<style lang="scss">
    .loading-box {
        display: flex;
        line-height: 2;
        position: relative;
        text-align: center;
        justify-content: center;
        height: 100vh;
        /*margin-top: calc(50% - 16px);*/
        .ivu-spin {
            display: flex;
            align-items: center;
            flex-direction: row;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue